import { render, staticRenderFns } from "./invoice.component.vue?vue&type=template&id=02fbdb1f&scoped=true&"
import script from "./invoice.component.vue?vue&type=script&lang=js&"
export * from "./invoice.component.vue?vue&type=script&lang=js&"
import style0 from "./invoice.component.vue?vue&type=style&index=0&id=02fbdb1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fbdb1f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAppBar,VBtn,VCard,VContainer,VIcon,VImg,VListItemSubtitle})
